import { Navigate } from "react-router-dom";


const ReferalRoute = ({ children, isAuthenticated, showReferalPage, temporaryToken }) => {

    // if (isAuthenticated) {
    //     return <Navigate to="../" replace />;
    // }
    // else if(showReferalPage) {
    if(showReferalPage) {
    	if(!temporaryToken) 
    		return <Navigate to="../login" replace />;
    }
    else if (!showReferalPage) {
        return <Navigate to="../" replace />;
    }

    return children;
}

export default ReferalRoute;
